import { InlineForm } from "./inline-form";
import { FormComponentsByType } from "../../form-field/form-field-type";
import { FormFieldSettings } from "../../form-settings/form-field-settings";
import { FormModel } from "../form-model";
import { InlineSettingsResolver } from "./inline-form-setting-resolver";
import { InlineModelResolver } from "./inline-form-model-resolver";

export class InlineFormFactory {
  private inlineSettingsResolver: InlineSettingsResolver;
  private inlineModelResolver: InlineModelResolver;

  constructor(defaultFormComponents?: FormComponentsByType) {
    this.inlineSettingsResolver = new InlineSettingsResolver(defaultFormComponents);
    this.inlineModelResolver = new InlineModelResolver();
  }

  public resolveSettings(inlineForm: InlineForm): FormFieldSettings {
    return this.inlineSettingsResolver.resolve(inlineForm);
  }

  public resolveModel(inlineForm: InlineForm): FormModel {
    return this.inlineModelResolver.resolve(inlineForm);
  }
}
